var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMovingBox = function SvgMovingBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.9,
    fillRule: "evenodd",
    d: "m9 .882 9 4.5v11.236l-9 4.5-9-4.5V5.382zM2 7.618v7.764l6 3v-7.764zm8 3v7.764l6-3V7.618zM14.764 6 9 8.882 7.236 8 13 5.118zm-4-2L9 3.118 3.236 6 5 6.882z",
    clipRule: "evenodd"
  })));
};
export { SvgMovingBox as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxOCAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkgMC44ODE4MzZMMTggNS4zODE4NFYxNi42MTc5TDkgMjEuMTE3OUwwIDE2LjYxNzlWNS4zODE4NEw5IDAuODgxODM2Wk0yIDcuNjE3OVYxNS4zODE4TDggMTguMzgxOFYxMC42MTc5TDIgNy42MTc5Wk0xMCAxMC42MTc5VjE4LjM4MThMMTYgMTUuMzgxOFY3LjYxNzlMMTAgMTAuNjE3OVpNMTQuNzYzOSA1Ljk5OTg3TDkgOC44ODE4NEw3LjIzNjA3IDcuOTk5ODdMMTMgNS4xMTc5TDE0Ljc2MzkgNS45OTk4N1pNMTAuNzYzOSAzLjk5OTg3TDkgMy4xMTc5TDMuMjM2MDcgNS45OTk4N0w1IDYuODgxODRMMTAuNzYzOSAzLjk5OTg3WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC45Ii8+Cjwvc3ZnPiAg";